import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type LoginFormArgs = {
	email: string;
	password: string;
};

@ValidatedClass()
class LoginFormData extends AbstractValidatedClass<LoginFormArgs> {
	@constraint(Joi.string().email({ tlds: false }), () => 'L’adresse e-mail est invalide')
	@constraint(Joi.string().required(), () => 'L’adresse e-mail est obligatoire')
	public readonly email: string;

	@constraint(Joi.string().required(), () => 'Le mot de passe est obligatoire')
	public readonly password: string;

	constructor(data: LoginFormArgs) {
		super(data);
		this.email = data.email;
		this.password = data.password;
		Object.freeze(this);
	}

	static createEmpty(): LoginFormData {
		return new LoginFormData({ email: '', password: '' });
	}

	setEmail(email: string): this {
		return this.cloneWith({ email } as Partial<LoginFormArgs>);
	}

	setPassword(password: string): this {
		return this.cloneWith({ password } as Partial<LoginFormArgs>);
	}
}

export default LoginFormData;
